import { Form, Input, InputNumber, Radio } from "antd";
import { useEffect } from "react";

export default function FeedbackManagementForm({ form, item }: any) {
    useEffect(() => {
        if (item.id) {
            form.setFieldsValue(item);
        }
    }, []);

    return (
        <Form form={form} size="small" name="FeedbackManagementForm" className='feedback-management-form' labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item label="反馈分类" name="category" rules={[{ required: true, message: '不能为空' }]} initialValue={true}>
                <Radio.Group>
                    <Radio value={'WHERE'}>从哪儿知道</Radio>
                    <Radio value={'DEMAND'}>需求</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="反馈类型名称" name="name" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入反馈类型名称" />
            </Form.Item>
            <Form.Item label="反馈类型排序" name="sortNum" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入反馈类型排序" style={{ width: '100%' }} />
            </Form.Item>
        </Form>
    )
}